import { NgModule } from '@angular/core';
import { MapPickComponent } from './map-pick.component';


@NgModule({
    declarations: [MapPickComponent],
    exports: [MapPickComponent]
})
export class MapPickModule { }
